"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxStrategy = void 0;
class MaxStrategy {
    calculate(samples) {
        return Math.max(...samples.map((result) => result.prioritizationFee));
    }
}
exports.MaxStrategy = MaxStrategy;
